// @ts-nocheck - suppress strict/type resolution errors in this legacy JS-heavy file
/// <reference path="../typings/global.d.ts" />


import { ApplicationListItem, IListItemData } from "../types/CommonTypes";
import { EquipmentListItem } from "../types/EquipmentTypes";

export class DropdownListUtility {

    public static LoadApplicationDropdownList(selector: string, listItems: ApplicationListItem[]) {

        if ($(selector).prop('tagName') != 'SELECT') return;
        $(selector + " option").remove();
        $(selector).append('<option value="">Select a Value</option>');
        for (var idx in listItems) {
            var item = listItems[idx];
            $(selector).append('<option value="' + item.VisionToken + '" data-code-type="' + item.StandardCodeId + '" >' + item.Description + '</option>');
        }
    }

    public static ClearDropdownList(selector: string) {
        $(selector + " option").remove();
        $(selector).append('<option value="">Select a Value</option>');
    }

    public static UpdateApplicationRequiredFieldDropdownList(selector: string, listItems: ApplicationListItem[]) {

        if ($(selector).prop('tagName') != 'SELECT') return;

        if ($(selector + ' option').length <= 0) {
            $(selector).append('<option value="">Select a Value</option>');
            for (var idx in listItems) {
                var item = listItems[idx];
                $(selector).append('<option value="' + item.VisionToken + '" data-code-type="' + item.StandardCodeId + '" >' + item.Description + '</option>');
            }
        } else if ($(selector + ' option').length <= 1) {
            for (var idx in listItems) {
                var item = listItems[idx];
                $(selector).append('<option value="' + item.VisionToken + '" data-code-type="' + item.StandardCodeId + '" >' + item.Description + '</option>');
            }
        } else {
            //update.
            $(selector + ' option').each((index, value) => {
                if ($(value).val()) {
                    let item = listItems.find(x => x.VisionToken == $(value).val());
                    $(value).attr('data-code-type', item.StandardCodeId);
                }
            })
        }
    }


    ///Doesnt use id as the value.
    public static LoadEquipmentSelectList(selector: string, listItems: EquipmentListItem[]) {

        $(selector + " option").remove();
        $(selector).append('<option value="">Select a Value</option>');
        for (var idx in listItems) {
            var item = listItems[idx];
            $(selector).append('<option value="' + item.VisionToken + '" data-code-type="' + item.StandardCodeId + '" >' + item.Description + '</option>');
        }
    }

    public static UpdateEquipmentRequiredFieldDropdownList(selector: string, listItems: EquipmentListItem[]) {

        if ($(selector).prop('tagName') != 'SELECT') return;

        if ($(selector + ' option').length <= 0) {
            $(selector).append('<option value="">Select a Value</option>');
            for (var idx in listItems) {
                var item = listItems[idx];
                $(selector).append('<option value="' + item.VisionToken + '" data-code-type="' + item.StandardCodeId + '" >' + item.Description + '</option>');
            }
        } else if ($(selector + ' option').length <= 1) {
            for (var idx in listItems) {
                var item = listItems[idx];
                $(selector).append('<option value="' + item.VisionToken + '" data-code-type="' + item.StandardCodeId + '" >' + item.Description + '</option>');
            }
        } else {
            //update.
            $(selector + ' option').each((index, value) => {
                if ($(value).val()) {
                    let item = listItems.find(x => x.VisionToken == $(value).val());
                    if (item) {
                        $(value).attr('data-code-type', item.StandardCodeId);
                    }
                }
            })
        }
    }

    static LoadListItemDropdownList(selector: string, listItems: IListItemData[], currentValue: string) {
        var currentValueFound = false;
        $(selector + " option").remove();
        $(selector).append('<option value="">Select a Value</option>');
        $.each(listItems, (index, value) => {
            if (!value.IsDisabled) {
                $(selector).append('<option value="' + value.VisionToken + '" data-item-id="' + value.Id + '">' + value.Description + '</option>');
            } else {
                $(selector).append('<option disabled value="' + value.VisionToken + '" data-item-id="' + value.Id + '">' + value.Description + '</option>');
            }
            
            if (currentValue == value.VisionToken) {
                currentValueFound = true;
            }
        });
        if (currentValueFound) {
            $(selector).val(currentValue);
        } else {
            $(selector).val("");
        }
    }

    static UpdateListItemDropdownList(selector: string, listItems: IListItemData[], currentValue: string) {

        var currentValueFound = false;

        if ($(selector + ' option').length <= 0) {
            $(selector).append('<option value="">Select a Value</option>');

            $.each(listItems, (index, value) => {
                $(selector).append('<option value="' + value.VisionToken + '" data-item-id="' + value.Id + '">' + value.Description + '</option>');
                if (currentValue == value.VisionToken) {
                    currentValueFound = true;
                }
            });
        } else if ($(selector + ' option').length <= 1) {
            $.each(listItems, (index, value) => {
                $(selector).append('<option value="' + value.VisionToken + '" data-item-id="' + value.Id + '">' + value.Description + '</option>');
                if (currentValue == value.VisionToken) {
                    currentValueFound = true;
                }
            });
        } else {
            $(selector + ' option').each((index, value) => {
                if ($(value).val()) {
                    let item = listItems.find(x => x.VisionToken == $(value).val());
                    if (item) {
                        $(value).attr('data-item-id', item.Id);
                    }
                }
            })
        }

    //    if (currentValueFound) {
    //        $(selector).val(currentValue);
    //    } else {
    //        $(selector).val("");
    //    }
    }




    //data is of type ListItemModel
    //FIXME. Remove all other instances of this function
    public static SetDropDownValues(data: any, sender: any, addDefault: boolean) {
        sender.empty();

        if (addDefault) {
            sender.prepend('<option value="" selected="selected">Select a Value</option>');
        }

        if (data.length > 0) {

            $.each(data, function (index, value) {
                if (value.IsSelected) {
                    sender.append('<option value="' + value.Id + '" selected="selected">' + value.Description + '</option>');
                }
                else {
                    sender.append('<option value="' + value.Id + '">' + value.Description + '</option>');
                }

            });
        }
    }

    public static PrePopulateDropDownOption(selector: string, onSelected: any) { 
        if ($(selector).length) {
            if ($(selector).find('option[value!=""]').length == 1) { 
                $(selector).prop("selectedIndex", 1);
                onSelected();
            }
        }
    }

}